"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RestoreObjectInput_1 = require("./RestoreObjectInput");
var RestoreObjectOutput_1 = require("./RestoreObjectOutput");
var ObjectAlreadyInActiveTierError_1 = require("./ObjectAlreadyInActiveTierError");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.RestoreObject = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "RestoreObject",
    http: {
        method: "POST",
        requestUri: "/{Bucket}/{Key+}?restore"
    },
    input: {
        shape: RestoreObjectInput_1.RestoreObjectInput
    },
    output: {
        shape: RestoreObjectOutput_1.RestoreObjectOutput
    },
    errors: [
        {
            shape: ObjectAlreadyInActiveTierError_1.ObjectAlreadyInActiveTierError
        }
    ]
};
//# sourceMappingURL=RestoreObject.js.map